(() => {
  const header = document.querySelector("[data-nativecos-header]");
  if (!header) return;

  const doc = document.documentElement;
  const body = document.body;
  const desktopMq = window.matchMedia("(min-width: 990px)");
  const shellWrap = header.querySelector(".nativecos-header-shell-wrap");
  const shell = header.querySelector(".nativecos-header-shell");
  const panels = Array.from(header.querySelectorAll("[data-nativecos-panel]"));
  const navLinks = Array.from(header.querySelectorAll("[data-nativecos-menu-target]"));
  const mobileToggle = header.querySelector("[data-nativecos-mobile-toggle]");
  const mobileDrawer = header.querySelector("[data-nativecos-mobile-drawer]");
  const mobileCloseButtons = Array.from(header.querySelectorAll("[data-nativecos-mobile-close]"));
  const panes = Array.from(header.querySelectorAll("[data-nativecos-pane]"));
  const paneButtons = Array.from(header.querySelectorAll("[data-nativecos-open-pane]"));
  const paneBackButtons = Array.from(header.querySelectorAll("[data-nativecos-pane-back]"));
  const closeDrawerLinks = Array.from(header.querySelectorAll("[data-nativecos-close-drawer]"));
  const searchButtons = Array.from(header.querySelectorAll("[data-nativecos-search]"));
  const cartButtons = Array.from(header.querySelectorAll("[data-nativecos-cart]"));
  const cartCounts = Array.from(header.querySelectorAll("[data-nativecos-cart-count]"));

  let activePanel = null;
  let closeTimer = null;
  let cartCountFetchPromise = null;

  function normalizeCartCount(value) {
    const count = Number(value);
    return Number.isFinite(count) && count >= 0 ? count : null;
  }

  function renderCartCount(itemCount) {
    if (!cartCounts.length) return;
    cartCounts.forEach((cartCount) => {
      cartCount.textContent = String(itemCount);
      cartCount.hidden = itemCount === 0;
    });
  }

  function getAnnouncementSection() {
    const bar = document.querySelector("#header-group .announcement-bar");
    return bar ? bar.closest(".shopify-section") : null;
  }

  function syncOffsets() {
    const announcementSection = getAnnouncementSection();
    const rect = announcementSection ? announcementSection.getBoundingClientRect() : null;
    const fullHeight = rect ? Math.round(rect.height) : 0;
    const visibleHeight = rect ? Math.max(0, Math.min(rect.bottom, rect.height)) : 0;
    doc.style.setProperty("--nativecos-announcement-height", `${fullHeight}px`);
    doc.style.setProperty("--nativecos-announcement-visible-height", `${Math.round(visibleHeight)}px`);
    if (shell) {
      doc.style.setProperty("--nativecos-shell-height", `${Math.round(shell.offsetHeight)}px`);
    }
  }

  function clearCloseTimer() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeDesktopPanels() {
    activePanel = null;
    header.removeAttribute("data-active-panel");
    panels.forEach((panel) => {
      panel.hidden = true;
      panel.classList.remove("is-active");
    });
    navLinks.forEach((link) => link.setAttribute("aria-expanded", "false"));
  }

  function scheduleDesktopClose() {
    clearCloseTimer();
    closeTimer = window.setTimeout(() => {
      closeDesktopPanels();
    }, 120);
  }

  function openDesktopPanel(key) {
    if (!desktopMq.matches) return;
    clearCloseTimer();
    activePanel = key;
    header.setAttribute("data-active-panel", key);
    panels.forEach((panel) => {
      const isMatch = panel.dataset.nativecosPanel === key;
      panel.hidden = !isMatch;
      panel.classList.toggle("is-active", isMatch);
    });
    navLinks.forEach((link) => {
      const isMatch = link.dataset.nativecosMenuTarget === key;
      link.setAttribute("aria-expanded", isMatch ? "true" : "false");
    });
  }

  function showPane(key) {
    panes.forEach((pane) => {
      const isMatch = pane.dataset.nativecosPane === key;
      pane.hidden = !isMatch;
      pane.classList.toggle("is-active", isMatch);
    });
  }

  function openMobileDrawer(targetPane = "main") {
    header.setAttribute("data-mobile-open", "true");
    body.classList.add("nativecos-mobile-menu-open");
    mobileDrawer.hidden = false;
    showPane(targetPane);
    mobileDrawer.scrollTop = 0;
    syncOffsets();
  }

  function closeMobileDrawer() {
    header.removeAttribute("data-mobile-open");
    body.classList.remove("nativecos-mobile-menu-open");
    if (!mobileDrawer) return;
    mobileDrawer.hidden = true;
    mobileDrawer.scrollTop = 0;
    showPane("main");
  }

  function proxySearch() {
    closeDesktopPanels();
    closeMobileDrawer();
    window.location.href = "/search";
  }

  function getCartDrawerComponent() {
    return (
      document.querySelector("#header-component cart-drawer-component") ||
      document.querySelector("#header-group cart-drawer-component") ||
      document.querySelector("cart-drawer-component")
    );
  }

  function openCartDrawerComponent() {
    const cartDrawer = getCartDrawerComponent();
    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
      return true;
    }
    return false;
  }

  function fallbackCartTrigger() {
    const stockTrigger =
      document.querySelector("#header-component [data-testid='cart-drawer-trigger']") ||
      document.querySelector("#header-group [data-testid='cart-drawer-trigger']");

    if (stockTrigger && stockTrigger.getClientRects().length > 0) {
      stockTrigger.click();
      return true;
    }

    return false;
  }

  function proxyCart(event) {
    event?.preventDefault();
    event?.stopPropagation();
    closeDesktopPanels();
    closeMobileDrawer();

    if (openCartDrawerComponent()) {
      return;
    }

    if (window.customElements && !customElements.get("cart-drawer-component")) {
      customElements.whenDefined("cart-drawer-component").then(() => {
        if (!openCartDrawerComponent() && !fallbackCartTrigger()) {
          window.location.href = "/cart";
        }
      });
      return;
    }

    if (fallbackCartTrigger()) return;

    window.location.href = "/cart";
  }

  async function updateCartCount() {
    if (!cartCounts.length) return;

    if (cartCountFetchPromise) {
      return cartCountFetchPromise;
    }

    cartCountFetchPromise = (async () => {
      try {
        const response = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error("cart fetch failed");
        const cart = await response.json();
        renderCartCount(normalizeCartCount(cart.item_count) ?? 0);
      } catch (_error) {
        // Keep the last visible count instead of flashing an incorrect zero on transient fetch failures.
      } finally {
        cartCountFetchPromise = null;
      }
    })();

    return cartCountFetchPromise;
  }

  function handleCartUpdate(event) {
    const resourceItemCount = normalizeCartCount(event.detail?.resource?.item_count);
    const dataItemCount = normalizeCartCount(event.detail?.data?.itemCount);

    if (resourceItemCount !== null) {
      renderCartCount(resourceItemCount);
      return;
    }

    if (dataItemCount !== null) {
      renderCartCount(dataItemCount);
      return;
    }

    updateCartCount();
  }

  navLinks.forEach((link) => {
    const target = link.dataset.nativecosMenuTarget;
    if (!target) return;
    link.addEventListener("pointerenter", () => openDesktopPanel(target));
    link.addEventListener("focus", () => openDesktopPanel(target));
  });

  panels.forEach((panel) => {
    panel.addEventListener("pointerenter", clearCloseTimer);
    panel.addEventListener("focusin", clearCloseTimer);
  });

  if (shellWrap) {
    shellWrap.addEventListener("pointerleave", () => {
      if (desktopMq.matches) scheduleDesktopClose();
    });
    shellWrap.addEventListener("focusout", (event) => {
      if (!shellWrap.contains(event.relatedTarget)) {
        closeDesktopPanels();
      }
    });
  }

  mobileToggle?.addEventListener("click", () => {
    if (header.hasAttribute("data-mobile-open")) {
      closeMobileDrawer();
      return;
    }
    openMobileDrawer("main");
  });

  paneButtons.forEach((button) => {
    button.addEventListener("click", () => {
      openMobileDrawer(button.dataset.nativecosOpenPane || "main");
    });
  });

  paneBackButtons.forEach((button) => {
    button.addEventListener("click", () => {
      showPane("main");
    });
  });

  mobileCloseButtons.forEach((button) => {
    button.addEventListener("click", () => {
      closeMobileDrawer();
    });
  });

  closeDrawerLinks.forEach((link) => {
    link.addEventListener("click", () => {
      closeMobileDrawer();
    });
  });

  searchButtons.forEach((button) => button.addEventListener("click", proxySearch));
  cartButtons.forEach((button) => button.addEventListener("click", proxyCart));

  document.addEventListener("pointerdown", (event) => {
    if (!header.contains(event.target)) {
      closeDesktopPanels();
      if (header.hasAttribute("data-mobile-open")) {
        closeMobileDrawer();
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDesktopPanels();
      closeMobileDrawer();
    }
  });

  window.addEventListener(
    "scroll",
    () => {
      syncOffsets();
      if (desktopMq.matches && activePanel) {
        closeDesktopPanels();
      }
    },
    { passive: true }
  );

  window.addEventListener("resize", () => {
    syncOffsets();
    if (!desktopMq.matches) {
      closeDesktopPanels();
      return;
    }
    closeDesktopPanels();
    closeMobileDrawer();
  });

  window.addEventListener("focus", updateCartCount);
  window.addEventListener("pageshow", updateCartCount);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) updateCartCount();
  });
  document.addEventListener("cart:update", handleCartUpdate);

  if (desktopMq.matches) {
    showPane("main");
  }

  syncOffsets();
  updateCartCount();
})();
